export default (props) => (
  /**
   * Ícone utilizado para representar enquandramento da camada cor parametrizada.
   * Encontrado no menu de ações de cada camada importada.
   */
  <svg
    width="15"
    height="11"
    viewBox="0 0 15 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3.98688"
      y="3.53911"
      width="7.14924"
      height="3.92888"
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.73255 0.548135V0.480957H0.732546V0.548135H0.566406V1.54813H0.732546L0.732546 3.23111H1.73255L1.73255 1.54813H3.56908V0.548135H1.73255Z"
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.73255 10.4595V10.5267H0.732546V10.4595H0.566406V9.45951H0.732546L0.732546 7.77653H1.73255L1.73255 9.45951H3.56908V10.4595H1.73255Z"
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.4003 0.548135V0.480957H14.4003V0.548135H14.5664V1.54813H14.4003L14.4003 3.23111H13.4003L13.4003 1.54813H11.5637V0.548135H13.4003Z"
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.4003 10.4595V10.5267H14.4003V10.4595H14.5664V9.45951H14.4003L14.4003 7.77653H13.4003L13.4003 9.45951H11.5637V10.4595H13.4003Z"
      fill={props.fill ? props.fill : 'currentColor'}
    />
  </svg>
);
